module.exports = __webpack_public_path__ + "static/media/17.3ac47e04.jpg";